import type { FaireProductEntity } from "../../entity_types/product";

export const p_zpp8zwtkkx: FaireProductEntity = {
  token: "p_zpp8zwtkkx",
  type: "product",
  name: "Puka Shell Necklace, Unisex White Square, Multiple Sizes",
  brandToken: "b_kqast86cfn",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/ffd6b235d62683c00811531b0668924f58275fdde147ab8e8305c8507abe301c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ee877a84dfb527fc76e470c3a27633c6761577b1b46d5bad2c753fed53addd1a.jpeg",
    "https://cdn.faire.com/fastly/17771681de892bbc8f55b2b63b6288dff2cc0bdf1c8368f10ab449cc099cfa31.jpeg",
    "https://cdn.faire.com/fastly/68bfdaf6cf4c335c03e9bb23bfb3aac9d0b3776ea0eacebc4fd5b3ba96ae3b0b.jpeg",
    "https://cdn.faire.com/fastly/c2812d1c25ceac3b999682d77153d94b49977007d0b8604c2b35c91f1e95d9da.jpeg",
    "https://cdn.faire.com/fastly/5306083a1cfd9dc8cdcc8018e0be5f94f99188be43cb0745a0ac1cadc63afc2c.jpeg",
    "https://cdn.faire.com/fastly/0f8ba8c043c7b3e1d933e22f17c99c93028b147a7467a5f24330d8244c011e6b.jpeg",
    "https://cdn.faire.com/fastly/3d62560a9a6401d6ec57b73fe1610c6ec57755247656f0770205f858977d52ff.jpeg",
    "https://cdn.faire.com/fastly/458c2ca8cc5fb7ff56c7db09caccde2573e6e4650737168cc8aaadddedabb93b.jpeg",
    "https://cdn.faire.com/fastly/52cd1658552016d5c855e53adde90bac1eaea2960f74835a41b16cb32d67a5c2.jpeg",
    "https://cdn.faire.com/fastly/9387a05a5af70b5165a3241f6c953ab60a2fdf733dcb84f83fdd4c9393e1a293.jpeg",
    "https://cdn.faire.com/fastly/cbc311d215d8d9cbd2a21cc300eb754a41d4f82729c55455944f718c3aa36285.jpeg",
  ],
  priceDollars: 6,
  msrpDollars: 12,
  description:
    '* Sizes 14", 16", 18", 20" available\n* UNIT= PC\n* Unisex Square puka necklace for men and women.  True fit is 2" less than the outer size due to the square shape of the shells\n * Lobster clasp closure or Barrel clasp closure (see product options to select your preference)\n * Includes 3" extender chain \n * Made with genuine white clam chip seashells',
  tags: [],
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/84e2f4b0b93011146882b0bb8c87dfc6154fcf726e0b76119462e6a6923aabd0.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:36.647Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
